import { Box, IBoxProps } from '@/src/packages/components/ui/Box';

export const Section = (props: IBoxProps) => {
  return <Box as="section" {...props} />;
};
